// Simple Support Page for FlexGym
import React from "react"

export default function SupportPage() {
  return (
    <main className="max-w-2xl mx-auto py-16 px-4">
      <a href="/" className="flex justify-center mb-8">
        <img src="/logo-with-text.png" alt="THE NOT FIT Logo" className="h-16 w-auto" />
      </a>
      <h1 className="text-3xl font-bold mb-6">Support</h1>
      <p className="mb-4">If you need assistance or have any questions about your membership, please contact us:</p>
      <ul className="list-disc ml-6 mb-4">
        <li>Email: <a href="mailto:support@ flexgym.com" className="text-blue-600 underline">support@thenotfit.com</a></li>
        <li>Phone: +1 234 567 8901</li>
        <li>Address: Rruga Komuna e Parisit, Tirane, Albania</li>
      </ul>
      <p className="mb-4">Our support team is available during regular gym hours. We aim to respond to all inquiries within 24 hours.</p>
      <p className="mt-8 text-sm text-muted-foreground">Thank you for being a part of FlexGym!</p>
    </main>
  )
}
